import React from 'react';
import { Route, Switch } from 'react-router-dom';
import connectRoutes from 'shared/hoc/withRoutes';
import { connectSideNav } from 'shared/hoc/withSideNav';
import { networkingViewCheck } from 'shared/api/networking';
import { MODULES } from 'shared/constants';
import * as routes from 'shared/routes/networking';
import BuildingTools from 'features/networking/core/BuildingTools';
import TenantRadiusSearch from 'features/networking/core/TenantRadiusSearch';
import ComplexTools from 'features/networking/core/ComplexTools';
import EquipmentManagement from 'features/networking/core/EquipmentManagement';

const withSideNav = connectSideNav(MODULES.networking);
const withRoutes = connectRoutes([
  {
    text: 'Tools',
    path: routes.buildingToolsPath,
    groupHead: routes.toolsPath,
    routeToTest: networkingViewCheck,
  },
  {
    RouteComponent: BuildingTools,
    text: 'Buildings',
    group: routes.toolsPath,
    path: routes.buildingToolsPath,
    routeToTest: networkingViewCheck,
  },
  {
    RouteComponent: ComplexTools,
    text: 'Complexes',
    group: routes.toolsPath,
    path: routes.complexToolsPath,
    routeToTest: networkingViewCheck,
  },
  {
    RouteComponent: EquipmentManagement,
    text: 'Equipment',
    path: routes.equipmentPath,
    routeToTest: networkingViewCheck,
  },
  {
    text: 'Radius',
    path: routes.tenantRadiusSearchPath,
    groupHead: routes.tenantRadiusSearchPath,
    routeToTest: networkingViewCheck,
  },
  {
    RouteComponent: TenantRadiusSearch,
    group: routes.tenantRadiusSearchPath,
    path: routes.tenantRadiusSearchPath,
    text: 'Tenant Radius Search',
    routeToTest: networkingViewCheck,
  },
]);

/**
 * @param {Object} props
 * @param {Array<Object>} props.enabledRoutes - Array of enabled route objects
 */
function Networking(props) {
  const {
    enabledRoutes,
  } = props;

  return (
    <Switch>
      {enabledRoutes.map((route) => (
        <Route
          exact
          key={route.path}
          path={route.path}
          component={route.RouteComponent}
        />
      ))}
    </Switch>
  );
}

export default {
  RouteComponent: withRoutes(withSideNav(Networking)),
  module: 'networking',
  name: 'Networking',
  path: routes.buildingToolsPath,
  rootPath: routes.rootPath,
  routeToTest: networkingViewCheck,
};
